/**
 * BOTTOM GENERAL INITS
 * STRUCTURE
 */

import { StructureMosaic } from "./structureMosaic";
import { StructureColumn3 } from "./structureColumn3";
import { StructureColumn4 } from "./structureColumn4";
import { StructureGallery } from "./structureGallery";
import { StructureRelatedCards } from "./structureRelatedCards";
import { StructureColumnTracking } from "./structureColumnTracking";
import { StructureProgramList } from "./structureProgramList";


export class StructureInits {
    structures = {
        mosaic: ".structure--mosaic",
        column3: ".structure--col-3",
        column4: ".structure--col-4",
        gallery: ".structure--gallery",
        relatedCards: ".structure--related-cards",
        programList: ".structure--program-list"
    };

    constructor() {
        this.initMap();
    }

    initMap() {
        if ($(this.structures.mosaic).length) {
            new StructureMosaic();
        }

        if ($(this.structures.column3).length) {
            new StructureColumn3();
        }

        if ($(this.structures.column4).length) {
            new StructureColumn4();
        }

        if ($(this.structures.gallery).length) {
            new StructureGallery();
        }

        if ($(this.structures.relatedCards).length) {
            new StructureRelatedCards();
        }

        if ($(this.structures.programList).length) {
            new StructureProgramList();
        }

        new StructureColumnTracking();
    }
}
